<template>
<div class="col-12 text-left">
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Customer Complaint Action Answer Form</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-2">
                <label for="module">Complaint Number</label>
                <input type="text" class="form-control" id="complaintNo" v-model="ccc.complaintNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Action Number</label>
                <input type="text" class="form-control" id="complaintNo" v-model="ccc.actionNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Target Date</label>
                <flat-pickr class="form-control" v-model="ccc.targetDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-2">
                <label >Root Cause Type</label>
                <input type="text" class="form-control" id="complaintNo" v-model="ccc.rootCauseType" disabled>
            </div>
            <div class="form-group col-2">
                <label >Action Type</label>
                <input type="text" class="form-control" id="complaintNo" v-model="ccc.actionType" disabled>
            </div>
            
            <!-- <div v-if="ccc.type === 'corrective'" class="form-group col-6">
                <label for="module">Corrective</label>
                <input type="text" class="form-control" id="complaintNo" v-model="ccc.corrective" disabled>
            </div>
            <div v-if="ccc.type === 'preventive'" class="form-group col-6">
                <label for="module">Preventive</label>
                <input type="text" class="form-control" id="complaintNo" v-model="ccc.preventive" disabled>
            </div> -->
        </div>
        <div class="row">
            <div v-if="this.ccc.item" class="form-group col-6">
                <label for="module">Item to be revised</label>
                <textarea class="form-control" id="desc-textarea" v-model="ccc.item" rows="2" disabled></textarea>
            </div>
            <div v-if="this.ccc.remark" class="form-group col-6">
                <label for="module">Comment</label>
               <textarea class="form-control" id="desc-textarea" v-model="ccc.remark" rows="2" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Root Cause Remark</label>
                <textarea class="form-control" id="desc-textarea" v-model="ccc.rootCauseRemark" rows="3" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Action Remark</label>
                <textarea class="form-control" id="desc-textarea" v-model="ccc.actionRemark" rows="3" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label for="module">Work Description</label>
                <textarea class="form-control" id="desc-textarea" v-model="ccc.workDescription" rows="2"></textarea>
            </div>
            <div class="form-group col-6">
                <label for="module">Please Submit your Investigation</label>
               <app-uploader :fileUrl="ccc.evidence" :fieldName="'evidence'" v-on:finishUpload="finishUpload(...arguments)"></app-uploader>
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="previewcparcc">Print CPAR-CC <i class="fas fa-print"></i></button>
        <button type="button" class="btn btn-outline-success" @click="previewccf">Print CCF <i class="fas fa-print"></i></button>
        <br /><br />
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { customerComplaintCorrective } from '../../models/customerComplaintCorrective'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppUploader from '../../components/AppUploader.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable, AppUploader
    },
    data() {
        return {
            ccc: {...customerComplaintCorrective},
        }
    },
    async created() {
        const isLogin = localStorage.getItem('ucf_token')
        if(isLogin) {
            if(this.$route.query.id !== undefined) {
            const query = {
                params: {
                    id: this.$route.query.id,
                    type: this.$route.query.type,
                    isRevision: this.$route.query.isrevision,
                }
            }
            const cccApi = api('customer-complaint-corrective-answer')
            this.ccc = await cccApi.getWithQuery(query)
            // this.ccc.customerComplaintCorrectiveDetail.isRevision = this.$route.query.isrevision
            console.log(this.ccc)
        }
        } else {
            this.$router.push({ name: 'login' })
        }
    },
    methods: {
        async save() {
            if(!this.$route.query.isrevision) {
                const cccApi = api('customer-complaint-corrective-answer')
                await cccApi.update(this.ccc, this.$route.query.id)
            } else {
                const cccApi = api('customer-complaint-corrective-answer-revision')
                await cccApi.update(this.ccc, this.$route.query.id)
            }
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        cancel() {
            // this.$router.go(-1)
        },
        previewcparcc() {
            if(this.selectedId !== '') {
                // this.$router.push({
                //     name: 'cpar-cc',
                //     query: {
                //         id: this.ccc.customerComplaintId
                //     }
                // })
                let newTab = this.$router.resolve({name: 'cpar-cc', query: {id: this.ccc.customerComplaintId}});
                window.open(newTab.href, '_blank');
            }
        },
        previewccf() {
            if(this.selectedId !== '') {
                // this.$router.push({
                //     name: 'ccf',
                //     query: {
                //         id: this.ccc.customerComplaintId
                //     }
                // })
                let newTab = this.$router.resolve({name: 'ccf', query: {id: this.ccc.customerComplaintId}});
                window.open(newTab.href, '_blank');
            }
        },
        finishLookup(data) {
            const currentccc = this.ccc
            this.ccc = {
                ...currentccc,
                ...data
            }
        },
        finishUpload(data) {
            const currentccc = this.ccc
            this.ccc = {
                ...currentccc,
                ...data
            }
        },
    }
}
</script>